module.exports = __webpack_public_path__ + "static/media/NSW.df56189c.png";